module.exports = __webpack_public_path__ + "static/media/title_bg5.e03ef47f.jpg";